module.exports = __webpack_public_path__ + "static/media/mt2.cdfe30d9.jpg";